import { Button } from "@emanprague/ppaskit";
import React from "react";
import styles from "./style.module.scss";

declare global {
  interface Window {
    // Wecoma cookie bar. Injected in index.html
    wlc: {
      openPrecen: () => void;
    };
  }
}

interface WecomaButtonProps {
  label: string;
  className?: string;
}

const WecomaButton: React.FC<WecomaButtonProps> = ({ label, className }) => {
  return (
    <Button
      variant="link"
      className={styles.wecomaButton + (className ? ` ${className}` : "")}
      onClick={() => window.wlc.openPrecen()}>
      {label}
    </Button>
  );
};

export default WecomaButton;
